export default {"src":"/_next/static/media/icon-play.73add3b1.svg","height":16,"width":14,"blurWidth":0,"blurHeight":0};